export const createLineItems = (physical_items, digital_items) => {
	let line_items = [];
	physical_items.forEach(element => {
		line_items.push({ quantity: element.quantity, item_id: element.id });
	});
	digital_items.forEach(element => {
		line_items.push({ quantity: element.quantity, item_id: element.id });
	});
	return line_items;
};
